import styled from 'styled-components'

import Col from '@components/atoms/Grid/Col'

export const Root = styled.div``

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
export const StyledCol = styled(Col)`
  flex-grow: 1;
  min-height: 100%;
  display: flex;
`
